<ng-container *ngIf="state$ | async as state; else navbarShimmer">

  <!-- RESTRICTED HEADER: RequestsReadonly contact — logo + Requests + optional Visitors + profile -->
  <p-menubar *ngIf="state.permissions.showRestrictedHeader; else fullNav" [model]="[]" styleClass="restricted-menubar">
    <ng-template pTemplate="start">
      <div class="left-wrap restricted-left-flex">
        <img [src]="state.logoUrl" alt="System Logo" height="25" routerLink="/" />
        <div class="btn-wrap">
          <button pButton type="button" label="Requests" (click)="goToRequests()"></button>
          <button
            *ngIf="state.permissions.hasVisitorsAccess"
            [style]="'margin-left: 0.5vw'"
            pButton type="button" label="Visitors"
            (click)="goToVisitors()"
          ></button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="end">
      <ng-container [ngTemplateOutlet]="profileMenuControl" [ngTemplateOutletContext]="{ $implicit: state }"></ng-container>
    </ng-template>
  </p-menubar>

  <!-- FULL NAV -->
  <ng-template #fullNav>
    <p-menubar [model]="state.items" styleClass="d-flex justify-content-end">
      <ng-template pTemplate="start">
        <div class="p-menuitem p-cursor p-px-3">
          <img [src]="state.logoUrl" alt="System Logo" height="25" routerLink="/" />

          <!-- Community dropdown — admin/employee only, not SOAViewer, not EPC.
               Loads independently of the rest of the navbar: shows its own loading chip
               instead of holding up contact search / profile dropdown while it fetches. -->
          <ng-container
            *ngIf="
              !state.permissions.soaViewerContact &&
              !state.permissions.epcContact &&
              (state.permissions.isEmployee || state.permissions.isAdmin)
            "
          >
            <div
              *ngIf="state.communityListLoading; else communityDropdown"
              class="community-dropdown-loading"
              data-cy="community-loading"
              aria-label="Loading Property Groups"
            ></div>
            <ng-template #communityDropdown>
              <p-select
                dropDownIcon="pi pi-user nav-user"
                panelStyleClass="dropdown-override"
                styleClass="dropdown-override"
                [resetFilterOnHide]="true"
                emptyFilterMessage="No community found"
                data-cy="community"
                [options]="state.communityList"
                optionLabel="name"
                placeholder="Global View"
                [ngModel]="state.selectedProject"
                [filter]="true"
                [filterBy]="'name'"
                (onChange)="changeValue($event)"
              >
                <ng-template let-item pTemplate="selectedItem">
                  <i class="selected-Community">{{ item?.name }}</i>
                </ng-template>
                <ng-template let-object pTemplate="item">
                  <i class="{{ object.icon }} icon"></i>
                  <i class="selected-Community">{{ object?.name }}</i>
                </ng-template>
              </p-select>
            </ng-template>
          </ng-container>
        </div>
      </ng-template>

      <div class="p-rightItems">

        <!-- Ask Sia — standalone button, admin/employee only, not EPC -->
        <ng-container
          *ngIf="
            siaEnabled &&
            !state.permissions.epcContact &&
            (state.permissions.isEmployee || state.permissions.isAdmin)
          "
        >
          <span class="sia-launcher-wrap sia-standalone">
            <button
              data-cy="sia-launcher"
              type="text"
              pButton
              icon="pi pi-comments"
              label="Ask Sia"
              (click)="toggleSia()"
            ></button>
          </span>
        </ng-container>

        <!-- Global search — admin/employee only, not EPC -->
        <div
          class="search-pill"
          *ngIf="
            !state.permissions.epcContact &&
            (state.permissions.isEmployee || state.permissions.isAdmin)
          "
        >
          <div class="search-col">
            <div class="navbar-search-input-wrap">
              <input
                type="search"
                autocomplete="off"
                aria-label="Global search"
                placeholder="Search..."
                [(ngModel)]="toSearch"
                (ngModelChange)="onSearchQueryChange($event)"
                (focus)="searchPanelOpen = true"
                (blur)="closeSearchPanel()"
              />
              <i class="pi pi-search" aria-hidden="true"></i>
            </div>

            <div
              *ngIf="searchPanelOpen && toSearch?.trim()"
              class="navbar-search-results"
              role="listbox"
            >
              <ng-container *ngIf="filteredGroups?.length; else noSearchResults">
                <section *ngFor="let group of filteredGroups; trackBy: trackSearchGroup" class="navbar-search-group">
                  <div class="navbar-search-group-header">
                    <img
                      *ngIf="group.value === 'contacts'"
                      src="/assets/icons/administration/contacts.svg"
                      alt="Contacts"
                    />
                    <img
                      *ngIf="group.value === 'units'"
                      src="/assets/icons/community/units.svg"
                      alt="Units"
                    />
                    <strong>{{ group.label }}</strong>
                  </div>
                  <button
                    *ngFor="let item of group.items; trackBy: trackSearchResult"
                    type="button"
                    class="navbar-search-result"
                    (mousedown)="$event.preventDefault()"
                    (click)="selectSearchResult(item)"
                  >
                    <span>{{ item.label }}</span>
                    <span *ngIf="item.type === 'contact' && item.value.vip" class="vip-badge">Restricted Unit</span>
                  </button>
                </section>
              </ng-container>
              <ng-template #noSearchResults>
                <div class="navbar-search-empty">No results found</div>
              </ng-template>
            </div>
          </div>
        </div>

        <span *ngIf="state.permissions.isContact || state.permissions.isVendor">
          <button
            data-cy="notifications"
            type="text"
            pButton
            pBadge
            [value]="state.notificationsCount"
            icon="pi pi-bell"
            (click)="op.toggle($event); getNotifications()"
          ></button>
        </span>

        <div class="navbar-divider" aria-hidden="true"></div>

        <!-- Profile dropdown -->
        <ng-container [ngTemplateOutlet]="profileMenuControl" [ngTemplateOutletContext]="{ $implicit: state }"></ng-container>

      </div>
 
    </p-menubar>

    <!-- Notifications popover: kept outside .p-rightItems so its host isn't an extra flex item (and gap) -->
    <p-popover #op [style]="{ width: '400px', 'max-height': '85vh' }" [baseZIndex]="10000">
      <div>
        <h5 *ngIf="recentNotifications?.length">Recent</h5>
        <p-divider *ngIf="recentNotifications?.length"></p-divider>
        <div *ngFor="let notification of recentNotifications">
          <a [href]="notification.url" class="a-style">
            <div [ngClass]="{ highlight: notification.status === 'new' || notification.status === 'seen' }">
              <div class="notificationIcon float-left p-pt-2 p-pl-1">
                <img style="height: 45px" [src]="notification.icon" />
              </div>
              <div class="p-pt-1 p-pl-1">
                <h6>{{ notificationTitle[notification.title] }}</h6>
                <div class="notificationBody">{{ notification.body }}</div>
              </div>
              <p-divider></p-divider>
            </div>
          </a>
        </div>
      </div>
      <div>
        <h5 *ngIf="oldNotifications?.length">Older Notifications</h5>
        <p-divider *ngIf="oldNotifications?.length"></p-divider>
        <div *ngFor="let notification of oldNotifications">
          <a [href]="notification.url" class="a-style">
            <div [ngClass]="{ highlight: notification.status === 'new' || notification.status === 'seen' }">
              <div class="notificationIcon float-left p-pt-2 p-pl-1">
                <img style="height: 45px" [src]="notification.icon" />
              </div>
              <div class="p-pt-1 p-pl-1">
                <h6 class="p-title">{{ notificationTitle[notification.title] }}</h6>
                <div class="notificationBody">{{ notification.body }}</div>
              </div>
              <p-divider></p-divider>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf="!recentNotifications?.length && !oldNotifications?.length">
        No Notifications
      </div>
    </p-popover>
  </ng-template>

  <!-- Forced password reset required modal -->
  <app-password-reset-dialog
    [visible]="showPasswordResetDialog"
    [usernameToDisallow]="passwordPolicyUsername"
    (confirm)="onPasswordResetDialogConfirm($event)">
  </app-password-reset-dialog>

  <!-- Profile menu: avatar, name and chevron are one trigger, so clicking any of them opens the menu -->
  <ng-template #profileMenuControl let-state>
    <!-- One wrapper so the p-menu host doesn't become its own flex item (and gap) in the navbar row -->
    <div class="profile-control">
      <button type="button" class="profile-trigger" data-cy="profile-menu" aria-haspopup="menu"
        [attr.aria-expanded]="profileMenuOpen"
        [title]="state.permissions.displayName || state.permissions.userEmail"
        (click)="profileMenu.toggle($event)">
        <p-avatar
          [label]="getUserInitials(state.permissions.displayName, state.permissions.userEmail)"
          shape="circle"
          class="profile-avatar"
          aria-hidden="true"
        ></p-avatar>
        <span class="profile-trigger-label">
          <span class="profile-trigger-name">{{ state.permissions.displayName || state.permissions.userEmail }}</span>
          <i class="pi pi-chevron-down" aria-hidden="true"></i>
        </span>
      </button>
      <p-menu #profileMenu [model]="profileMenuModel(state.profileItems)" [popup]="true" appendTo="body"
        (onShow)="profileMenuOpen = true" (onHide)="profileMenuOpen = false"></p-menu>
    </div>
  </ng-template>

</ng-container>

<ng-template #navbarShimmer>
  <div class="navbar-shimmer">
    <div class="shimmer-left">
      <img *ngIf="logoUrl$ | async as shimmerLogo; else shimmerLogoPlaceholder" [src]="shimmerLogo" alt="Logo" height="28" class="shimmer-logo-img" />
      <ng-template #shimmerLogoPlaceholder><div class="shimmer-block shimmer-logo"></div></ng-template>
      <!-- Same placeholder the real nav uses for the community dropdown (see #communityDropdown
           above) - so this bootstrap-phase shimmer and the post-permissions loading chip read as
           one continuous loader in this slot, not two different-looking ones back to back. -->
      <div class="community-dropdown-loading"></div>
      <div class="shimmer-block shimmer-item"></div>
      <div class="shimmer-block shimmer-item"></div>
    </div>
    <div class="shimmer-right">
      <div class="shimmer-block shimmer-profile"></div>
    </div>
  </div>
</ng-template>
